/*
*   悬浮视频窗口组件
*   zxw
*   2024-10-29
*/

import React, { useState ,useEffect, useRef} from 'react';
import Draggable from 'react-draggable';
import ReactPlayer from 'react-player';
import $ from 'jquery';
import { AddRequestHeaders,} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config';

const LiveStreamPlayer = (props) => {
    const [open, setOpen] = useState(false); 
    const [url, setUrl] = useState('');

    useEffect(()=>{
        setOpen(props.open);
        setUrl(props.url);
    }, [props]);

    return (
        open?<ReactPlayer 
            url={url}
            playing={true} 
            muted={false} 
            loop={true}
            width={492}
            height={354}
            controls
            playsinline
            onError={(error) => console.error('网络错误:', error)}
        />:null
    );
};
 
const FloatVideoWindow = (props) => {
    const [open, setOpen] = useState(false);
    const [lsUrls, setLsUrls] = useState([]);
    
    // const deleteLSUrls = (record) => {
    //     $.ajax({
    //         url: `${CNF.api}vs/devls/urls`,
    //         headers: AddRequestHeaders(),
    //         type: 'DELETE',
    //         dataType: 'JSON',
    //         data:JSON.stringify({
    //             'serial_number': record.serial_number,
    //             'channel_number': record.channel_number,
    //             'url_type': record.url_type,
    //             'platform_number': record.platform_number,
    //             'live_token': record.live_token,
    //         }),success:function(data){
    //             if(data.res === 0){
    //                 //
    //             }else{
    //                 //
    //             }
    //         }
    //     })
    // };
  
    useEffect(()=>{
        setOpen(props.open);
    }, [props]);

    useEffect(()=>{
        setOpen(props.open);
        if(open){
            //  获取直播地址
            $.ajax({
                url: `${CNF.api}vs/devls/urls`,
                headers: AddRequestHeaders(),
                type: 'GET',success:function(data){
                    if(data.res === 0){
                        if(data.dat.length > 0){
                            console.log(data.dat);
                            setLsUrls(data.dat);
                        }else{
                            setLsUrls([]);
                        }
                    }else{
                        message.error(data.msg, 1.5);
                    }
                }
            })
        }
    }, [open]);
  
    return (
        <Draggable>
            <div style={{ 
                zIndex: 99999,
                position: 'absolute',
                left: 10,
                top: 35,
                display: open ? 'block' : 'none'
            }}>
                {
                    open&&lsUrls&&lsUrls.length>0&&lsUrls.map((item, index) => (
                        <LiveStreamPlayer 
                            key={index} 
                            url={item.url_hd?item.url_hd:item.url} 
                            open={open}
                        />
                    ))
                }
            </div>
        </Draggable>
    );
};
 
export default FloatVideoWindow;